import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "amfe-flexible/index"; // rem布局
import "normalize.css/normalize.css"; // css初始化
import "@/assets/css/icon.css"; // 字体图标
import VueQuillEditor from "vue-quill-editor"; // 富文本编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import  { UrlSearch } from "./assets/js/Fun.js";//获取地址栏参数
import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});
// import SignCanvas from 'sign-canvas';
// Vue.use(SignCanvas);
let Request= new UrlSearch();
Vue.prototype.$Request=Request;
Vue.prototype.$axios = axios;
Vue.use(VueQuillEditor, { placeholder: "请输入内容" });
import { Lazyload } from "vant"; // 图片懒加载
axios.defaults.baseURL = '/'  //关键代码
Vue.config.productionTip = false
Vue.use(Lazyload);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
